import { SvgReliefComposer } from '@modules/Vector/S/Function/composite/svg.relief-composer.ts';
import { MakerProfile } from '@modules/NewMaker/FlexiMaker/F/Function/flexmaker.types.ts';
import {
  JOGAK_STIKER_PRODUCT,
  PLUSH_PRODUCT,
  TTIBU_PRODUCT,
} from '@modules/NewMaker/FlexiMaker/S/Constant/fleximaker';
import { RELIEF_OPTIONS } from '@modules/Vector/S/Constant/doll.constant.ts';
import { SvgUtil } from '@modules/Vector/S/Function/util.svg.ts';
import { mapRange } from '@modules/NewMaker/FlexiMaker/F/Function/flexmaker.helper.ts';
import { composeSvgOverBg } from '@modules/NewMaker/FlexiMaker/F/Function/ttibu.thumbnail.ts';
import { ImageUtil } from '@modules/Vector/S/Function/util.image.ts';

const DefaultProfile: MakerProfile = {
  name: 'default',
  shouldApply: () => true,
  is_background_fixed: false,
};

// 3) 봉제인형 전용
const PlushProfile: MakerProfile = {
  name: 'plush',
  shouldApply: ({ bpId }) => bpId === PLUSH_PRODUCT.ID,
  customOption: () => ({
    offset: PLUSH_PRODUCT.OFFSET,
    materialSource: PLUSH_PRODUCT.MATERIAL_SOURCE,
  }),
  stickerizerOptions: () => ({
    afterprocessFn: async (svg: string) => SvgReliefComposer.composeWithRelief(svg, RELIEF_OPTIONS.PLUSH),
    strokeStyle: undefined,
    smoothOffsetAdder: RELIEF_OPTIONS.SMOOTH_OFFSET_ADDER,
    thumbnailExpandMargin: RELIEF_OPTIONS.THUMBNAIL_EXPAND_MARGIN,
    expandMargin: () => {
      const offset = G.mp.maker.flexiMaker?.offsetDistance;

      if (!offset) return 0;
      return RELIEF_OPTIONS.PRINTING_FILE_OFFSET - offset;
    },
  }),
  calOffset: (sliderValue: number) => {
    return mapRange(sliderValue, 0, 1, 17, 20);
  },
  previewImage: {
    imageUrl:
      '//s3.marpple.co/files/u_2798351/2025/10/original/117128b4efc4b694ed187bb5fe4eaedc695cd8a91.png',
    alt: '봉제인형',
  },
  is_background_fixed: false,
};

const MpsJogakStickerProfile: MakerProfile = {
  name: 'mps_jogak_sticker',
  shouldApply: ({ bpId }) => {
    return bpId === JOGAK_STIKER_PRODUCT.ID && G.collabo_type !== '';
  },
  stickerizerOptions: () => ({
    // 마플샵에서는 그림자 효과가 적용되어야함
    afterprocessFn: async (svg: string) => SvgUtil.injectDropShadow(svg),
  }),
  is_background_fixed: false,
};

const TTIBUProfile: MakerProfile = {
  name: 'ttibu',
  shouldApply: ({ bpId }) => bpId === TTIBU_PRODUCT.ID,
  customOption: () => ({
    offset: TTIBU_PRODUCT.OFFSET,
    materialSource: TTIBU_PRODUCT.MATERIAL_SOURCE,
  }),
  stickerizerOptions: () => ({
    thumbnailExpandMargin: 1,
    afterprocessFn: async (svg: string) => {
      // return svg;
      async function makeThumbnailSpec() {
        function toPx(mm: number) {
          return Math.round(((mm * 0.1) / 2.54) * 300);
        }
        const canvas = (await ImageUtil.makeCanvasByUrl(
          '//s3.marpple.co/files/u_193535/2025/10/original/269b5713c84b2ac2be34c4af10128f93c1e831e31.png',
          // '//s3.marpple.co/files/u_193535/2025/10/original/5ddfa5995d79bf67ee6ba7a8bcd607e2ab5619fc1.png',
        )) as HTMLCanvasElement;
        /* 프린트 영역이 위아래 중앙에 오도록 하는게 중요*/
        const bg = {
          width: 1000,
          height: 1000,
          item: {
            width: 558,
            width_mm: 38,
          },
        };
        const mm_per_px = bg.item.width_mm / bg.item.width;
        return {
          img_url: canvas.toDataURL(),
          width: toPx(bg.width * mm_per_px),
          height: toPx(bg.height * mm_per_px),
        };
      }

      return composeSvgOverBg(svg, await makeThumbnailSpec(), (innerSvg) => {
        const stroke_color = '#e1e1e1';
        const storke_el = innerSvg.querySelector('g');
        storke_el?.setAttribute('stroke', stroke_color);
        storke_el?.removeAttribute('stroke-dasharray');
      });
    },
  }),
  guide_image_url:
    '//s3.marpple.co/files/u_193535/2025/10/original/60b984524ac5942a6dec3cd11329081b3d36f68b2.png',
  previewImage: {
    imageUrl: '//s3.marpple.co/files/u_193535/2025/10/original/2d3a04dc1b0e7d6db3e7501396cfb1a238ff68a41.png',
    alt: '띠부스티커',
  },
  is_background_fixed: true,
  initial_size: {
    width: 34,
    height: 46,
    scale: 1,
  },
};

const PROFILES: MakerProfile[] = [MpsJogakStickerProfile, PlushProfile, TTIBUProfile, DefaultProfile];

export const pickProfile = (ctx: { bpId?: number }) =>
  PROFILES.find((p) => p.shouldApply(ctx)) ?? DefaultProfile;
